import React, {Fragment} from 'react';
import {Goals, Route, Switch, Layout, NavLink} from 'components';
import {config} from 'helpers';
import {RouteComponentProps} from 'types';

export function Router({location: {pathname}}: RouteComponentProps) {
  return (
    <Fragment>
      <Layout.Title>Goals</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink to="/goals/" exact={Boolean(pathname.match(/\bprojects|track|weekly\b/))}>My Goals</NavLink>
        <NavLink to="/goals/weekly-objectives/">Weekly Objectives</NavLink>
        <NavLink to="/goals/track/">My Results</NavLink>
        <NavLink to="/goals/projects/">Projects</NavLink>
      </Layout.Topbar.Tabs>
      <Switch>
        { config.sw && <Route path="/goals/projects/" component={Goals.Projects.Sidebar} /> }
        <Route path="/goals/weekly-objectives/" component={Goals.WeeklyObjectives.Sidebar} />
        <Route path="/goals/:page(track)/:id?" component={Goals.Sidebar} />
        <Route component={Goals.Sidebar} />
      </Switch>
      <main>
        <Switch>
          { config.sw && <Route path="/goals/projects/:id" component={Goals.Projects.View} /> }
          { config.sw && <Route path="/goals/projects/" component={Goals.Projects.Home} /> }
          <Route path="/goals/weekly-objectives/add/" component={Goals.WeeklyObjectives.EditForm} />
          <Route path={['/goals/weekly-objectives/:page(track)/:id/', '/goals/weekly-objectives/:id/']} component={Goals.WeeklyObjectives.Router} />
          <Route path="/goals/weekly-objectives/" component={Goals.WeeklyObjectives.Home} />
          <Route path="/goals/set/" component={Goals.Single.EditForm} />
          <Route path="/goals/track/" component={Goals.Home} exact />
          <Route path={['/goals/:page(track)/:id/', '/goals/:id/']} component={Goals.Single.Router} />
          <Route path="/goals/" component={Goals.Home} />
        </Switch>
      </main>
    </Fragment>
  );
}
